<script>
import verHistoriaClinica from "../verHistoriaClinica/verHistoriaClinica";
import GestionOrdenes from "../GestionOrdenes/GestionOrdenes";
import EncuentrosExistentes from "../EncuentrosExistentes/EncuentrosExistentes";
import SeguimientoPaciente from "../Seguimiento/SeguimientoPaciente/SeguimientoPaciente";
import Icono from "../Icono/Icono";
import SubirArchivo from "../SubirArchivo/SubirArchivo";
import tarjetasNuevasMomento from "../TarjetasNuevasMomento/TrajetasNuevasMomento";
import marcacionesPrograma from "../MarcacionesPrograma/marcacionesPrograma";
import VerEncuentrosSeguimientos from "../VerEncuentrosSeguimientos/VerEncuentrosSeguimientos";
export default {
  data() {
    return {
      
      overlay: true,
      deshabilitado: true,
      verCompleto: true,
      banderaVerHC:true, 
      comprobarCamposObligatorios:false,
      nuevaTarjeta: "",
      encuentroSeguimiento: null
    };
  },
  props: {
    verComponente: {
      type: String,
      default: null
    },
    coleccion: {
      type: String,
      default: null
    },
    paciente: {
      type: Object,
      default: {}
    },
    banderaSubirArchivo: {
      type: Boolean,
      default: true
    },
    datosMarcacionesPrograma: {
      type: Array,
      default: () => []
    }
  },
  mounted() {},
  created() {
    console.log('se creo overlay')
  },
  components: {
    GestionOrdenes,
    EncuentrosExistentes,
    SeguimientoPaciente,
    Icono,
    SubirArchivo,
    verHistoriaClinica,
    tarjetasNuevasMomento,
    marcacionesPrograma,
    VerEncuentrosSeguimientos
  },
  methods: {
    cerrarAbrirOverlay: function(valor) {
      this.overlay = !this.overlay;
      this.$emit("formularioActualizado", this.overlay);
      this.$emit("overlay", this.overlay);
    },
    cerrarOverlay: function(valor) {
      // this.comprobarCamposObligatorios=false
      if(this.verComponente=='verFormulario'){
        this.comprobarCamposObligatorios=true
      }else{
        this.overlay = false;
        this.$emit("cerrarOverlay", this.overlay);
      }
    },
    cerrarSinActualizar(){
        this.overlay = false;
        this.$emit("cerrarOverlay", this.overlay);
    },
    volverHC(){
      this.banderaVerHC=false
      const self= this
      setTimeout(function() {
        self.banderaVerHC=true
      }, 100);
    },
  },
};
</script>
<template src='./formularioOverlay.html'></template>
<style lang="scss" scoped src='./formularioOverlay.scss'></style>
<style lang="scss" >
@import "../../assets/sass/main";
.v-dialog {
  @extend .scrollbar;
}
</style>



// WEBPACK FOOTER //
// src/components/formularioOverlay/formularioOverlay.vue